import {reverse} from "~/urls";
import React from "react";
import {useHistory} from "react-router";
import useQueryParam from "~/hooks/useQueryParam";
import ReactLink from "~/components/ReactLink";

export default function EntityBackToListLink({url, ...props}) {
  const history = useHistory();
  const listQuery = useQueryParam(history, 'list_ctx', "");

  return (
    <ReactLink
      to={reverse(url) + '?' + listQuery}
      {...props}>
      &lt; back to list
    </ReactLink>
  )
}
